(function() {
    $(document).ready(function() {
	    console.log("Swell Initialized");
        $(".wrapper").addClass("swell-rewards");
        $(document).on("swell:setup", function() {
            SwellConfig.Referral.initializeReferral(".swell-referral");
            SwellConfig.Referral.populateReferrals();
          
            $(".swell-referral-loader").hide();
            $(".swell-post-checkout .checkout-heading .swell-referral-back-link").click(function() {
                $(".swell-post-checkout").hide();
            });
            SwellConfig.Tier.initializeDummyTier();
            if(spapi.authenticated) {
                SwellConfig.Tier.setupCustomerTierName();
            }
            SwellConfig.Tier.initializeCustomTierProperties();
            SwellConfig.Tier.initializeTiers(".swell-tier-table");
            SwellConfig.Tier.initializeSlider();
        });

        $(document).on("click", ".swell-referral-copy .swell-referral-back-link-holder", function() {
            $(".swell-referral-copy").hide();
        });

        $(document).on('click', '.swell-post-checkout .swell-referral-thanks-heading .swell-referral-back-link', function(e) {
            $(".swell-post-checkout").hide();
        });

        $(document).on("swell:referral:success", function() {
            swellAPI.refreshCustomerDetails(function() {
                $(".table-data").html("");
                SwellConfig.Referral.populateReferrals();
            });
        });

        $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
            if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
                $(".refer-customer-error").remove();
                $(".swell-referral-form-list").after('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
            }

            if (textStatus && textStatus === "Please enter a valid email address") {
                $(".refer-customer-error").remove();
                $(".swell-referral-form-list").after('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
            }
        });

        $('body').on('click', '.swell-referral-copy', function(e) {
            if ($(e.target).hasClass("swell-referral-copy")) {
                e.stopPropagation();
            }
        });
    });
}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Campaign = {
        opts: {
            templates: {
                campaign: "<li class='swell-campaign'><div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'><div class='swell-campaign-icon'><span class='swell-campaign-icon-content'><i class='swell-icon <%= campaign.icon %>'><span class='path1'></span> <span class='path2'></span> <span class='path3'></span> <span class='path4'></span> <span class='path5'></span> <span class='path6'></span></i></span></div><div class='swell-campaign-value'><span class='swell-campaign-value-content'><%= campaign.reward_text %></span></div><div class='swell-campaign-type'><span class='swell-campaign-type-content'><%= campaign.title %></span></div></div></li>"
            }
        }
    };

}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Referral = {
        opts: {
            localization: {
                referralRegisterHeading: "Give <%= referralCampaign.reward_text %>, Get $30",
                referralRegisterFormDetails: "Enter your email below to get started.",
                referralReferHeading: "Give <%= referralCampaign.reward_text %>, Get $30",
                referralThanksHeading: "Thanks for your referral(s)!",
                referralReferMediaDetails: "You can also share your link with the buttons below.",
                referralReferFormDetails: "Share your referral link now:",
                referralReferFormEmailsDetails: "",
                referralReferFormEmails: "Your friends’ emails (separated by commas)",
                referralRegisterFormEmail: "Enter email",
                referralRegisterFormSubmit: "Next",
                referralReferFormSubmit: "Send",
                referralCopyButton: "Copy Link",
                referralCopyDetails: "Copy link and share with your friends.",
                referralRegisterDetails: "Give your friends $30 off their first purchase of $200+ CAD. You’ll receive a $30 off coupon code for every successful referral.",
                referralReferDetails: "Give your friends $30 off their first purchase of $200+ CAD. You’ll receive a $30 off coupon code for every successful referral."
            },
            templates: {
                referralRegister: '<div class="swell-referral-register"><h2 class="swell-referral-heading swell-heading">Refer-A-Friend</h2><h2 class="swell-referral-heading-small"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details swell-text"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-body"> <p class="swell-referral-form-text swell-text"><%= localization.referralRegisterFormDetails %></p> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" autocomplete="off" name="swell-referral-register-email" id="swell-referral-register-email" swellrequired="swellrequired" placeholder="<%= localization.referralRegisterFormEmail %>"><input class="swell-referral-form-list-submit swell-text" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"></li></ul> </div> </form> </div> </div>',
                referralRefer: '<div class="swell-referral-refer"><h2 class="swell-referral-heading swell-heading">Refer-A-Friend</h2><h2 class="swell-referral-heading-small"><%= localization.referralRegisterHeading %></h2>  <p class="swell-referral-details swell-text"><%= localization.referralReferDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-body"> <p class="swell-referral-form-text swell-text"><%= localization.referralReferFormDetails %></p> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" autocomplete="off" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>"><input class="swell-referral-form-list-submit swell-text" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"></li></ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details swell-text"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content swell-text"> <i class="swell-referral-media-icon swell-icon-facebook-share-3" aria-hidden="true"></i>Share </div> </li> <li class="swell-referral-medium swell-mobile swell-share-referral-sms"> <div class="swell-referral-medium-content swell-text"> <i class="swell-referral-media-icon swell-icon-sms-1" aria-hidden="true"></i>SMS </div> </li>  <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content swell-text"> <i class="swell-referral-media-icon swell-icon-tweet-3" aria-hidden="true"></i>&nbsp;Tweet</div> </li>  <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content swell-text"> <i class="swell-referral-media-icon swell-icon-fb-message-3" aria-hidden="true"></i>Message </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content swell-text"> <i class="swell-referral-media-icon swell-icon-copylink-3" aria-hidden="true"></i>Copy Link </div> </li> </ul> </div> </div>'
            }
        },
        initializeReferral: function(containerSelector) {
          var email = $(containerSelector).data("customer-email");
          if (email) {
            spapi.storage.setItem("referrer_email", email);
            spapi.customer.email = email;
          }
          Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        },
        populateReferrals: function() {
            if (spapi.authenticated) {
                var referral_receipts = spapi.customer.referral_receipts;
                referral_receipts.forEach(function(referral_receipt) {
                    var email = referral_receipt.email;
                    var completed_at = referral_receipt.completed_at;
                    if (completed_at) {
                        status = "purchased (" + spapi.activeReferralCampaign.reward_text + "earned)";
                    } else {
                        status = "invited";
                    }
                    $(".table-data").append("<tr class='swell-table-row'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
                });
            }
        }
    };
}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Tier = {
        getCustomerTierId: function() {
            var customer_tier, intro_tier, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier) {
                return customer_tier.id;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].id;
                } else {
                    return null;
                }
            }
        },
        getCustomerTierRank: function() {
            var customer_tier, intro_tier, rank, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier && customer_tier.id) {
                rank = $.grep(tiers, function(e) {
                    return e.id === customer_tier.id;
                })[0].rank;
                return rank;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].rank;
                } else {
                    return null;
                }
            }
        },
        getTierByRank: function(rank) {
            var tiers;
            tiers = spapi.activeVipTiers;
            return $.grep(tiers, function(e) {
                return e.rank === rank;
            })[0];
        },
        setupCustomerTierStatus: function() {
            var columnLength, customer_tier_id, customer_tier_rank, data_id, next_tier, spend_required, current = 2;
            customer_tier_id = SwellConfig.Tier.getCustomerTierId();
            customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();

            next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
            columnLength = $(".swell-tier-table .swell-tier-table-body").children().length;
            
            

            if (customer_tier_id == spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
                $(".swell-tier-table-body .swell-tier-list:nth-child("+columnLength+") .tier-list:nth-child(1)").addClass("swell-current");
                $(".swell-tier-table-body .swell-tier-list:nth-child("+columnLength+") .tier-list:nth-child(1).tier-name").before("<div class='tier-list tier-status swell-current'></div>");
               // $(".swell-tier-table-body .swell-tier-list:nth-child("+columnLength+") .tier-status").append("<span class='swell-current-status'>Current Status</span>");
                $(".swell-tier-table-body .swell-tier-list:nth-child("+columnLength+")").addClass("tier-active");
               // $(".swell-next-tier").html("Congrats, you're in the highest tier!");
                $("#login .swell-next-tier").html("Congrats, you're in the highest tier!");
                current = columnLength;
            } else {
                if(swellAPI.getCustomerDetails().vipTierStats) {
                    spend_required = ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100).toFixed(2);
                } else {
                    spend_required = spapi.activeVipTiers[1].prettyAmountSpent.toFixed(2);
                }
                if(spend_required < 0) {
                    spend_required = 0;
                }
                
                
                
                
                
                
                var $myDivPerks = $(".swell-spent-required");
                
                    if ( $myDivPerks.length){
                    
                    $(".swell-spent-required").html(spend_required);
                    $(".swell-next-tier-name").html(next_tier.name);
                    
                    }
                

                for (counter = 1; counter <= columnLength; counter++) {
                    data_id = $(".swell-tier-table .swell-tier-table-body li:nth-child(" + counter + ")").data("tier-id");

                    if (data_id == customer_tier_id) {
                        $(".swell-tier-table-body .swell-tier-list:nth-child("+counter+") .tier-list:nth-child(1)").addClass("swell-current");
                        $(".swell-tier-table-body .swell-tier-list:nth-child("+(counter+1)+") .tier-list:nth-child(1)").addClass("swell-current");
                        $(".swell-tier-table-body .swell-tier-list:nth-child("+counter+") .tier-list:nth-child(1).tier-name").before("<div class='tier-list tier-status swell-current'></div>");
                        $(".swell-tier-table-body .swell-tier-list:nth-child("+(counter+1)+") .tier-list:nth-child(1).tier-name").before("<div class='tier-list tier-status swell-current'></div>");
                         // $(".swell-tier-table-body .swell-tier-list:nth-child("+counter+") .tier-status").append("<span class='swell-current-status'>Current Status</span>"); 
                        // $(".swell-tier-table-body .swell-tier-list:nth-child("+(counter+1)+") .tier-status").append("<span class='swell-current-status swell-next-status'>Spend $" + spend_required + " more for " + next_tier.name + "</span>"); 
                        $(".swell-tier-table-body .swell-tier-list:nth-child("+counter+")").addClass("tier-active");
						$(".swell-spent-required").html(spend_required);
						$(".swell-next-tier-name").html(next_tier.name);

                    }
                    
                     
                    
                    
                }
            }

            return current;
        },
        initializeDummyTier: function() {
            var k, len, tier, tiers;
            tiers = spapi.activeVipTiers;
            for (k = 0, len = tiers.length; k < len; k++) {
                tier = tiers[k];
                tier.rank += 1;
            }
            return tiers.unshift({
                id: -1,
                rank: 0,
                name: "Core Crew",
                points: "Just for joining",
                point_multiplier: "1x",
                swellrequiredAmountSpent: "$0",
                swellrequiredAmountSpentCents: 0,
                swellrequiredPointsEarned: 0,
                swellrequiredPurchasesMade: 0,
                swellrequiredReferralsCompleted: 0
            });
        },
        initializeCustomTierProperties: function() {
            spapi.activeVipTiers[0].tier_spend = "$0 - $" + (spapi.activeVipTiers[1].amount_spent_cents/100-1);
            spapi.activeVipTiers[1].tier_spend = ("$"+(spapi.activeVipTiers[1].amount_spent_cents/100) + " - $"+((spapi.activeVipTiers[2].amount_spent_cents/100)-1));
            spapi.activeVipTiers[2].tier_spend = (spapi.activeVipTiers[2].amount_spent_cents/100+"+");
        },
        initializeTiers: function(containerSelector) {
            // $(".swell-tier-table .swell-tier-table-header").append("<li class='swell-tier-list'><div class='tier-list tier-status swell-current'><span class='swell-current-status'></span></div><div class='tier-list tier-name'>Benefits</div>  <div class='tier-list'>Poppy Perks Month annual sale</div> <div class='tier-list'>Birthday week</div> <div class='tier-list'>Free shipping</div> <div class='tier-list'>Early BIS notifications</div> <div class='tier-list'>Early access to sales</div> <div class='tier-list'>Early access to collection drops</div><div class='tier-list'><a href='/pages/poppy-perks-flats-giveaway'>Quarterly giveaways</a></div><div class='tier-list'>Invites to VIP shop events</div></li>");
            // 
            // 
            // $(".swell-tier-table .swell-tier-table-body").append("<li class='swell-tier-list tier-insider' data-tier-id='"+spapi.activeVipTiers[0].id+"'><div class='tier-list tier-status swell-current'><span class='swell-current-status'></span></div> <div class='tier-list tier-name'><span class='tier-list-name'>"+spapi.activeVipTiers[0].name+"</span><div class='tier-list tier-value'><span class='rolling-year-value'>"+spapi.activeVipTiers[0].tier_spend+"</span></div></div>  <div class='tier-list'>10% off</div> <div class='tier-list'> $10 off </div><div class='tier-list'> Over $200 </div>  <div class='tier-list'>1 hour before email list</div> <div class='tier-list'><div class='circle'></div></div> <div class='tier-list'><div class='circle'></div></div><div class='tier-list'></div><div class='tier-list'></div>  </li>");
            // 
            // 
            // $(".swell-tier-table .swell-tier-table-body").append("<li class='swell-tier-list tier-core-crew' data-tier-id='"+spapi.activeVipTiers[1].id+"'> <div class='tier-list tier-status swell-current'><span class='swell-current-status'></span></div><div class='tier-list tier-name'><span class='tier-list-name'>"+spapi.activeVipTiers[1].name+"</span><div class='tier-list tier-value'><span class='rolling-year-value'>"+spapi.activeVipTiers[1].tier_spend+"</span></div></div>  <div class='tier-list'> 15% off </div> <div class='tier-list'> $20 off </div><div class='tier-list'> Over $200 </div>  <div class='tier-list'>1 hour before email list</div> <div class='tier-list'><div class='circle'></div></div> <div class='tier-list'><div class='circle'></div></div><div class='tier-list'><div class='circle'></div></div><div class='tier-list'></div></li>");
            // 
            // 
            // $(".swell-tier-table .swell-tier-table-body").append("<li class='swell-tier-list tier-iconer' data-tier-id='"+spapi.activeVipTiers[2].id+"'><div class='tier-list tier-status swell-current'><span class='swell-current-status'></span></div><div class='tier-list tier-name'><span class='tier-list-name'>"+spapi.activeVipTiers[2].name+"</span><div class='tier-list tier-value'><span class='rolling-year-value'>$"+spapi.activeVipTiers[2].tier_spend+"</span></div></div>  <div class='tier-list'>20% off for you and one friend</div> <div class='tier-list'> $30 off </div><div class='tier-list'> Free </div>  <div class='tier-list'> 2 hours before email list </div> <div class='tier-list'> <div class='circle'></div> </div> <div class='tier-list'> <div class='circle'></div> </div><div class='tier-list'><div class='circle'></div></div><div class='tier-list'> <div class='circle'></div> </div> </li>");
            
            if(spapi.authenticated) {
                current_tier = SwellConfig.Tier.setupCustomerTierStatus();
            }
        },
        initializeSlider: function() {
            $('.swell-tier-table .swell-tier-table-body').slick({
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                responsive: [
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true
                  }
              }
              ]
            });       
        },
        setupCustomerTierName: function() {
            if(spapi.customer.vip_tier) {
                $(".banner-status .swell-current-tier").html(spapi.customer.vip_tier.name);
                $("#login .swell-current-tier").html(spapi.customer.vip_tier.name);
                $(".swell-current-tier").html(spapi.customer.vip_tier.name);
            } else {
                $(".banner-status .swell-current-tier").html(spapi.activeVipTiers[0].name);
                $("#login .swell-current-tier").html(spapi.activeVipTiers[0].name);
                $(".swell-current-tier").html(spapi.activeVipTiers[0].name);
            }
        } 
    };
}).call(this);



